// Cambiar a SalesDocumentType
export enum DocumentType {
  /**
   * Cotización.
   */
  QUOTATION = 1,
  /**
   * Orden de venta.
   */
  SALES_ORDER = 2,
}
